<template>
    <v-autocomplete
        id="tenantlists"
        outlined
        :background-color="bgcolor"
        :color='textFieldOutline'
        :label="label"
        :items="valuesList"
        v-model="selectedList"
        item-value="key"
        item-text="value"
        multiple
        chips
    >
    <template v-slot:prepend-item>
            <v-list-item
                ripple
                @mousedown.prevent
                @click="selectAll()"
            >
                <v-list-item-action>
                    <v-icon v-if="selectAllStatus" color="primary">check_box</v-icon>
                    <v-icon v-else>check_box_outline_blank</v-icon>
                </v-list-item-action> 
                <v-list-item-content>
                    <v-list-item-title>
                        Select All
                    </v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <v-divider class="mt-2"></v-divider>
        </template>
    <template v-slot:selection="{ item, index }">
        <v-chip small class="chipsclass" v-if="index <= 0 " :title="item.value">
            <span>{{item.value }}</span>
        </v-chip>
            <span
                v-if="(index === 1)"
                class="grey--text text-caption"
            >
            (+{{ selectedList.length - 1 }})
            </span>
    </template>
    </v-autocomplete>
</template>

<script>
import Vue from 'vue';
export default {
    name:'dropdown',
    data(){
        return{
            selectedList: this.selectedValues,
            selectAllStatus: false
        }
    },
    props:{
        label : {
            type : String
        },
        bgcolor : {
            type : String
        },
        valuesList: {
            type:Array,
            default() {
                return []
            }
        },
        selectedValues : {
            type:Array,
            default() {
                return []
            }
        },
        textFieldOutline: {
            type : String
        }
    },
    created(){
    },
    computed:{

    },
    watch:{
        selectedList(){
            this.$emit('selectedValuesList',this.selectedList)
        },
        selectedValues(){
            // console.log(this.selectedValues)
            this.selectedList = this.selectedValues
        }
    },
    methods:{
        selectAll(){
            var self =this;
            if (self.selectAllStatus) {
                self.selectedList = [];
                self.selectAllStatus = false;
            } else if(!self.selectAllStatus){
                for(let value in self.valuesList){
                    self.selectedList.push(self.valuesList[value]['key'])
                }
                self.selectAllStatus = true;
            }
        }
    }
}
</script>

<style scoped lang="scss">
.chipsclass{
    max-width:5rem;
}
.chipsclass span{
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.v-text-field.v-text-field--enclosed .v-text-field__details {
    padding-top: 0;
     margin-bottom: unset !important; 
}

.v-select.v-select--chips:not(.v-text-field--single-line).v-text-field--box .v-select__selections, .v-select.v-select--chips:not(.v-text-field--single-line).v-text-field--enclosed .v-select__selections {
    min-height: unset !important;
}
</style>